import bars_icon from "assets/icons/bars_icon.svg";
import checkmark from "assets/icons/checkmark.svg";
import info from "assets/icons/summary/info.svg";
import close from "assets/icons/summary/close.svg";
import twitch from "assets/icons/summary/twitch.svg";
import steam from "assets/icons/summary/steam.svg";
import playstation from "assets/icons/summary/playstation.svg";
import nintendo from "assets/icons/summary/nintendo.svg";
import arrow_back from "assets/icons/quiz/arrow_back.svg";
import list_dot from "assets/icons/checkout/list_dot.svg";
import star from "assets/icons/checkout/star.svg";
import expand_more from "assets/icons/checkout/expand_more.svg";

export const icons: Record<
  string,
  React.FunctionComponent<React.SVGProps<SVGSVGElement>>
> = {
  bars_icon,
  checkmark,
  info,
  close,
  twitch,
  steam,
  playstation,
  nintendo,
  arrow_back,
  list_dot,
  star,
  expand_more,
};
